export const AmplitudeEvent = {
  // APP
  APP_LOGGED_IN: 'App start: Logged in',
  // DEVX
  DEVX_SANDBOX_DEVELOPER_LOGGED_IN: 'DevX : SB: Action - Developer Logged in',
  DEVX_SANDBOX_CLICKED_GO_LIVE: 'DevX: SB: Click - Clicked Go Live',
  DEVX_SANDBOX_CLICKED_SIGN_UP: 'DevX: SB: Click - Sign up button',
  DEVX_SANDBOX_CLICKED_GENERATE_API_KEY: 'DevX: SB: Click - Generate API Keys button',
  DEVX_SANDBOX_CLICKED_READ_DOCS: 'DevX: SB: Click - Read docs',
  DEVX_SANDBOX_CLICKED_READ_API_REF: 'DevX: SB: Click - Read API reference',
  DEVX_SANDBOX_CLICKED_VIEW_WALLETS: 'DevX: SB: Click - View wallets',
  DEVX_SANDBOX_CLICKED_LEARN_ABOUT_WALLETS: 'DevX: SB: Click - Learn more about wallets',
  DEVX_SANDBOX_CLICKED_CREATE_MERCHANT: 'DevX: SB: Click - Create a Merchant',
  DEVX_SANDBOX_CLICKED_MERCHANT_LEARN_MORE: 'DevX: SB: Click - Learn more about on Merchant page',
  DEVX_SANDBOX_CLICKED_CREATE_PAYMENT: 'DevX: SB: Click - Create a Payment',
  DEVX_SANDBOX_CLICKED_CONTACT_SALES: 'DevX: SB: Click - Contact Sales team',
  DEVX_PROD_CLICKED_SIGN_UP: 'DevX: PD: Click - Sign up button',
  // CHANNELS
  CHANNEL_CREATION_STARTED: 'Channel creation started',
  CHANNEL_DETAILS_VIEWED: 'Channel Details Viewed',
  CHANNEL_CREATION_SUCCESS: 'Channel creation success',
  CREATE_CHANNEL: 'Channel Transactions Create Channel',
  CHANNEL_EDITING_SUCCESS: 'EOF Channel: Edit Success',

  // WALLETS
  WALLET_CLICK_WALLET_CREATED_SUCCESSFULLY: 'MP - Wallet - Created successfully',
  WALLET_TRANSACTION_HISTORY_TAB_VIEWED: 'Transaction History tab viewed',
  WALLET_TRANSACTION_HISTORY_SEARCHED: 'Transaction History Search',
  WALLET_TRANSACTION_NO_SEARCH_RESULTS: 'Transaction History Search - No Search Results',
  TRANSACTION_MODAL_CUSTOMER_REFERENCE_COPIED: 'Wallet Search Modal - Customer reference copied',
  TRANSACTION_MODAL_WALLET_ADDRESS_COPIED: 'Wallet Search Modal - Wallet address copied',
  TRANSACTION_SIDE_PANEL_CUSTOMER_REFERENCE_COPIED:
    'Wallet Search Side Panel - Customer reference copied',
  TRANSACTION_SIDE_PANEL_WALLET_ADDRESS_COPIED: 'Wallet Search Side Panel - Wallet address copied',
  TRANSACTION_MODAL_UUID_COPIED: 'Wallet Search Modal - Transaction UUID copied',
  TRANSACTION_MODAL_HASH_COPIED: 'Wallet Search Modal - Hash copied',
  TRANSACTION_SIDE_PANEL_UUID_COPIED: 'Wallet Search Side Panel - Transaction UUID copied',
  TRANSACTION_SIDE_PANEL_HASH_COPIED: 'Wallet Search Side Panel - Hash copied',
  // WALLETS - Convert
  WALLET_CLICK_PRE_QUOTE_REQUEST: 'MP - Wallet - Convert - Rate check (pre-quote)',
  WALLET_CLICK_QUOTE_REQUEST: 'MP - Wallet - Convert - Quotation check request',
  WALLET_CLICK_CONVERSION_SUCCESS: 'MP - Wallet - Conversion success',
  // ONBOARDING
  ONBOARDING_CLICK_SIGNUP_TOP_LINK: 'ONB - Sign up top link',
  ONBOARDING_LOAD_CTA_GET_STARTED: 'ONB - Page Load - CTA Get Started',
  ONBOARDING_CLICK_CONTINUE_CTA_GET_STARTED: 'ONB - Continue - CTA Get Started',
  ONBOARDING_CONFIRM_EMAIL: 'ONB - Confirmed email',
  ONBOARDING_CLICK_RESEND_EMAIL_VERIFICATION: 'ONB - Resend email verification code',
  // HOMEPAGE
  HOMEPAGE_TOTAL_USERS: 'HOME - Total users',
  HOMEPAGE_CLICK_MERCHANT_DETAILS: 'HOME - Add merchant details',
  HOMEPAGE_CLICK_CREATE_PAYMENT: 'HOME - Create Payment',
  HOMEPAGE_CLICK_VIEW_ALL_WALLETS: 'HOME - View all wallets',
  HOMEPAGE_CLICK_GENERATE_API_KEYS: 'HOME - Generate API keys',
  // MANAGE ACOUNT (SETTINGS)
  MANAGE_ACCOUNT_VIEWED: 'Manage Account Page Viewed',
  MANAGE_ACCOUNT_API_KEY_CREATED: 'API key created',
  MANAGE_ACCOUNT_TEAM_MEMBER_ADDED: 'Team Member added',
  MANAGE_ACCOUNT_TEAM_MEMBER_UPDATED: 'Team Member updated',
  MANAGE_ACCOUNT_BANK_ACCOUNT_ADDED: 'Bank Account account added',
  MANAGE_ACCOUNT_MANAGE_MERCHANTS_ADDED: 'Manage Merchants merchant added',
  MANAGE_ACCOUNT_MANAGE_MERCHANTS_UPDATED: 'Manage Merchants merchant updated',

  // VERSION 2 EVENTS (REWORK)

  // DASHBOARD (HOMEPAGE)
  DASHBOARD_HOME: 'Dashboard: Home',

  // DEVX (HOMEPAGE)
  DEVX_HOME: 'DevX: Home',

  // WALLETS
  WALLET_HOME: 'Wallet: Home',
  WALLET_CONVERT: 'Wallet: Convert',
  WALLET_POPOVER_MENU: 'Wallet: Popover Menu',

  // WALLET DETAILS
  WALLET_DETAILS: 'Wallet: Wallet Details',
  WALLET_DETAILS_PAY: 'Wallet Details: Pay',
  WALLET_DETAILS_WITHDRAW: 'Wallet Details: Withdraw',
  WALLET_DETAILS_DEPOSIT: 'Wallet Details: Deposit',
  WALLET_DETAILS_CONVERT: 'Wallet Details: Convert',
  WALLET_DETAILS_SEND: 'Wallet Details: Send',
  WALLET_DETAILS_RECEIVE: 'Wallet Details: Receive',

  // TRANSACTION HISTORY
  TRANSACTION_HISTORY_HOME: 'Transaction History: Home',

  // PAY
  PAY_INITIATE: 'Pay: Initiate',
  PAY_INPUT_AMOUNT: 'Pay: Input Amount',
  PAY_CONFIRM: 'Pay: Confirm',
  PAY_SUCCESS: 'EOF Pay: Success',

  // WITHDRAW
  WITHDRAW_INITIATE: 'Withdraw: Initiate',
  WITHDRAW_CONFIRM: 'Withdraw: Confirm',
  WITHDRAW_SUCCESS: 'EOF Withdraw: Success',

  // DEPOSIT
  DEPOSIT_INITIATE: 'Deposit: Initiate',
  DEPOSIT_COPY: 'Deposit: Copy',
  EOF_DEPOSIT_SUCCESS: 'EOF Deposit: Success',

  // CONVERT
  CONVERT_INITIATE: 'Convert: Initiate',
  CONVERT_CONFIRM: 'Convert: Confirm',
  CONVERT_REFRESH: 'Convert: Refresh Quote',
  CONVERT_SUCCESS: 'EOF Convert: Success',

  // SEND
  SEND_INITIATE: 'Send: Initiate',
  SEND_CONFIRM: 'Send: Confirm',
  EOF_SEND_SUCCESS: 'EOF Send: Success',

  // NOTABENE
  SEND_NOTABENE_INITIATE: 'Send: Notabene Widget Initiate',
  SEND_NOTABENE_ERROR: 'Send: Notabene Widget Error',

  // RECEIVE
  RECEIVE_INITIATE: 'Receive: Initiate',
  RECEIVE_COPY: 'Receive: Copy',

  // MANAGE ACCOUNT
  MANAGE_ACCOUNT: 'Manage Account: Home',
  MANAGE_ACCOUNT_MANAGE_CRYPTO_ADDRESSES: 'Manage Account: Manage Crypto Addresses',

  // ADD CRYPTO ADDRESS WHITELIST
  ADD_CRYPTO_ADDRESS_WHITELIST_INITIATE: 'Add Crypto Address Whitelist: Initiate',
  ADD_CRYPTO_ADDRESS_WHITELIST_CONFIRM: 'Add Crypto Address Whitelist: Confirm',
  EOF_ADD_CRYPTO_ADDRESS_WHITELIST_SUCCESS: 'EOF Add Crypto Address Whitelist: Success',

  // DELETE CRYPTO ADDRESS WHITELIST
  DELETE_CRYPTO_ADDRESS_WHITELIST_INITIATE: 'Delete Crypto Address Whitelist: Initiate',
  EOF_DELETE_CRYPTO_ADDRESS_WHITELIST_SUCCESS: 'EOF Delete Crypto Address Whitelist: Success',

  // MANAGE BENEFICIARIES
  MANAGE_BENEFICIARIES: 'Manage Account: Manage Beneficiaries',
  MANAGE_BENEFICIARIES_COPY: 'Manage Beneficiaries: Copy',

  // ADD BENEFICIARY
  ADD_BENEFICARY_SELECT_DESTINATION: 'Add Beneficiary: Select Destination',
  ADD_BENEFICIARY_INITIATE: 'Add Beneficiary: Initiate',
  ADD_BENEFICIARY_CONFIRM: 'Add Beneficary: Confirm',
  EOF_ADD_BENEFICIARY_SUCCESS: 'EOF Add Beneficiary: Success',

  // DELETE BENEFICIARY
  DELETE_BENEFICIARY_INITIATE: 'Delete Beneficiary: Initiate',
  EOF_DELETE_BENEFICIARY_SUCCESS: 'EOF Delete Beneficiary: Success',

  // PAYMENTS: MASS PAYOUTS
  MASS_PAYOUTS: 'Mass Payouts: Home',

  // PAYMENT LINKS
  PAYMENTS: 'Payments Home',
  PAYMENT_INITIATE: 'Create Payment: Initiate',
  EOF_PAYMENT: 'Create Payment: Success',
} as const

export type AmplitudeEventType = (typeof AmplitudeEvent)[keyof typeof AmplitudeEvent]

export const AmplitudeEventCategory = {
  APPLICATION: 'Application',
  MERCHANT_PORTAL: 'Merchant Portal',
  MANAGE_CRYPTO_ADDRESS: 'Manage Crypto Address',
  ONBOARDING: 'Onboarding',
  SIGNUP: 'Signup',
  WALLET: 'Wallet',
  WALLET_TRANSACTION_EXPORT: 'WalletTransactionExport',
  WALLET_TRANSACTION_SEARCH: 'Wallet Transaction Search',
  WALLET_SEARCH_TRANSACTION_MODAL: 'Wallet Transaction Search Modal',
  WALLET_SEARCH_TRANSACTION_SIDE_PANEL: 'Wallet Transaction Search Side Panel',
  MANAGE_BENEFICIARIES_SIDE_PANEL: 'Manage Beneficiaries Side Panel',
} as const

export const AmplitudeEventAction = {
  LOAD: 'load',
  NAVIGATE: 'navigate',
  COPY: 'copy',
  CLICK: 'click',
  SEARCH: 'search',
  VERIFIED: 'verified',
  WHITELIST: 'whitelist',
  ERROR: 'error',
  VIEW: 'view',
  REFRESH: 'refresh',
} as const
